var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenaltyShootoutStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11,24.68v3.7A1.08,1.08,0,0,0,12,29.46h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.79 30.38 15.79 32.38 13.17 32.38 13.17 29.23 13.17 28.47",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79,32.38V38.5a1.31,1.31,0,0,1-1.31,1.31h0a1.31,1.31,0,0,1-1.31-1.31V32.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.79 32.38 18.41 32.38 18.41 28.47",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79,32.38V38.5a1.31,1.31,0,0,0,1.31,1.31h0a1.31,1.31,0,0,0,1.31-1.31V32.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.6,
    cy: 13.6,
    r: 2.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.42,19.47a2.88,2.88,0,0,0-2.06-1h-.59a2.11,2.11,0,0,1-1.17.34,2.15,2.15,0,0,1-1.18-.35h-.55A2.93,2.93,0,0,0,11,21.38v3.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.13,24.68v3.7a1.08,1.08,0,0,1-1.08,1.08h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.13,24.68v-3.3a2.93,2.93,0,0,0-2.92-2.93h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.03,
    y1: 29.46,
    x2: 12.38,
    y2: 29.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12.79 13.51 12.79 2.49 37.21 2.49 37.21 13.51",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.3,
    y1: 13.51,
    x2: 48.74,
    y2: 13.51,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.26,
    y1: 13.51,
    x2: 13.23,
    y2: 13.51,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.83,
    y1: 19.82,
    x2: 25.34,
    y2: 19.82,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7.62 13.51 5.75 19.82 11.09 19.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "43.05 13.51 44.93 19.82 25.34 19.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.46,42.67a4.5,4.5,0,0,0-1-.3l-.6-.18a.59.59,0,0,1-.25-.15.18.18,0,0,1-.05-.15.21.21,0,0,1,.1-.21,1,1,0,0,1,.84,0,.36.36,0,0,1,.17.23.37.37,0,0,0,.38.22h.75a.31.31,0,0,0,.24-.1.32.32,0,0,0,.09-.23A1.29,1.29,0,0,0,28,41.3a1.73,1.73,0,0,0-.4-.47,2.17,2.17,0,0,0-.64-.35,2.9,2.9,0,0,0-1.89.06,1.65,1.65,0,0,0-.7.56,1.38,1.38,0,0,0-.26.82,1.4,1.4,0,0,0,.21.78,1.51,1.51,0,0,0,.6.51,4,4,0,0,0,.9.29c.27.06.49.13.65.18a1,1,0,0,1,.31.16.16.16,0,0,1,.06.15.27.27,0,0,1-.14.23,1.08,1.08,0,0,1-.55.11,1.07,1.07,0,0,1-.39-.06.6.6,0,0,1-.22-.14.42.42,0,0,1-.11-.16l0,0-.12-.12a.34.34,0,0,0-.25-.08H24.3a.29.29,0,0,0-.23.1.33.33,0,0,0-.09.23,1.32,1.32,0,0,0,.27.75,1.74,1.74,0,0,0,.73.55,2.83,2.83,0,0,0,1.16.21,3.07,3.07,0,0,0,1.09-.19,1.75,1.75,0,0,0,.77-.55,1.54,1.54,0,0,0,.09-1.66A1.46,1.46,0,0,0,27.46,42.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.37,41.62a.33.33,0,0,0,.1-.24v-.61a.34.34,0,0,0-.35-.35H28.59a.31.31,0,0,0-.24.1.32.32,0,0,0-.1.25v.61a.33.33,0,0,0,.1.24.31.31,0,0,0,.24.1h1v3.43a.39.39,0,0,0,.1.25.4.4,0,0,0,.26.1h.74a.36.36,0,0,0,.36-.35V41.72h1A.32.32,0,0,0,32.37,41.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.18,40.73a.41.41,0,0,0-.14-.21.39.39,0,0,0-.29-.1h-.86a.39.39,0,0,0-.29.1.41.41,0,0,0-.13.2l-1.61,4.35a.34.34,0,0,0,0,.1.29.29,0,0,0,.09.22.3.3,0,0,0,.23.11h.7a.4.4,0,0,0,.28-.1.63.63,0,0,0,.11-.15l.24-.64h1.64l.25.63a.35.35,0,0,0,.1.16.41.41,0,0,0,.28.1h.7a.37.37,0,0,0,.24-.1.38.38,0,0,0,.08-.23.53.53,0,0,0,0-.12Zm-.43,2.64h-.87l.44-1.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.34,43.5a1.71,1.71,0,0,0,.53-.47,1.71,1.71,0,0,0-.29-2.19,2.26,2.26,0,0,0-1.44-.42H37.36a.34.34,0,0,0-.35.35v4.38a.33.33,0,0,0,.1.25.36.36,0,0,0,.25.1h.73a.36.36,0,0,0,.25-.1.35.35,0,0,0,.1-.25V43.77H39l.77,1.44a.88.88,0,0,0,.12.17.44.44,0,0,0,.32.12h.74a.32.32,0,0,0,.33-.33.37.37,0,0,0-.05-.16Zm-.68-1.4a.39.39,0,0,1-.12.33.59.59,0,0,1-.42.12h-.68v-.92h.68a.59.59,0,0,1,.42.12A.43.43,0,0,1,39.66,42.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.32,40.52a.32.32,0,0,0-.25-.1H41.55a.33.33,0,0,0-.25.1.32.32,0,0,0-.1.25v.61a.33.33,0,0,0,.1.24.33.33,0,0,0,.25.1h1v3.43a.35.35,0,0,0,.1.25.36.36,0,0,0,.25.1h.75a.37.37,0,0,0,.25-.1.39.39,0,0,0,.1-.25V41.72h1a.35.35,0,0,0,.26-.1.37.37,0,0,0,.1-.24v-.61A.33.33,0,0,0,45.32,40.52Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.34,
    cy: 32.29,
    rx: 2.75,
    ry: 2.38,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.57,
    y1: 34.67,
    x2: 29.1,
    y2: 34.67,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 5.5,
    r: 0.34,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "22.49 8.82 23.71 7.61 26.3 7.61 27.51 8.81",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "23.46 13.23 23.46 11.47 24.63 10.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.54 13.23 26.54 11.47 25.37 10.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.77,
    y1: 8.21,
    x2: 24.77,
    y2: 10.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.23,
    y1: 8.21,
    x2: 25.23,
    y2: 10.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.06,
    y: 38.11,
    width: 25.28,
    height: 9.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenaltyShootoutStart);
export default __webpack_public_path__ + "static/media/PENALTY_SHOOTOUT_START.567d780e3f6a14ee219ef292a2e853d2.svg";
export { ForwardRef as ReactComponent };